// css style
import styled from "styled-components";
// media query
import { device } from "./LayoutResponse";
 
 
// For SideBar

const SideBar = styled.div`
  min-height: 100vh;
  max-height: 100vh;
  background-color: #FBFBFB;
  top:76px;
  position: absolute;
  left: 0; 
  width: 270px;
  height: 100%;
  z-index: 10000; 
  -webkit-box-shadow: 15px 0px 12px -17px rgba(0,0,0,0.52);
  -moz-box-shadow: 15px 0px 12px -17px rgba(0,0,0,0.52);
  box-shadow: 15px 0px 12px -18px rgba(0,0,0,0.52);
  

  @media ${device.tablet}{
    left: -400px;
    z-index: 10000;
  top:0px;
    transition: all 0.4s linear;
    -webkit-box-shadow:none;
    -moz-box-shadow: none;
    box-shadow:none;
  }
`;

// For Right Side Content
const Content = styled.div`
  background-color: #FFFFFF;
  padding-top:170px;
  padding-left: 270px;
 min-height:90vh; 
 max-height:90vh; 
   display:flex;
   flex-direction:column;
 overflow-x: hidden;
  overflow-y: auto;

  @media ${device.tablet}{
    padding: 170px 0px 0px;
  }
`;


 
 

export {  SideBar, Content };
